/**
 * Purpose:
 * Runtime shell host for dashboard routes.
 * Why:
 * Uses the simple shell until platform_mode resolves, then switches to the
 * matching authenticated workspace shell.
 */
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AppLayoutType, APP_LAYOUTS } from '@modules/navigation/models';
import { AppLayoutService } from '@modules/navigation/services';

@Component({
    selector: 'cwr-app-layout-host',
    templateUrl: './app-layout-host.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLayoutHostComponent implements OnInit {
    @Input() static = false;
    @Input() light = false;
    @Input() rtl = false;
    @Input() sideNavVisilibity = true;

    readonly appLayouts = APP_LAYOUTS;
    activeLayout: AppLayoutType = APP_LAYOUTS.USER_SIMPLE;

    constructor(private readonly appLayoutService: AppLayoutService) {}

    ngOnInit(): void {
        this.activeLayout = this.appLayoutService.resolveDashboardLayout();
    }
}

